/**
 * Author: Ricardo Tovar
 * 
 * Ellipsizer is a jQuery plugin that truncates a text into a given number of lines, and adds an ellipsis (...)
 * at the end if the text was truncated. It stores the original text, and can be called on window resize for
 * a responsive experience.
 * 
 * It also adds a 'title' property to the HTML element if the text was truncated, containing the full original text.
 * 
 * Usage:
 * 
 * You can call it without parameters, eg. $(element).ellipsizer(). It will truncate the element to 1 line.
 * 
 * If you pass an int value as the parameter, Ellipsizer will truncate the text for that ammount of lines, eg $(element).ellipsizer(4)
 * 
 * You can specify a data attribute in the html element for specifying the number of lines. Eg.:
 * 
 * <p id="a-paragraph" data-ellipsizer-lines="3">
 *  Lorem ipsum dolor sit amet, consectetur adipiscing elit. In efficitur eget leo in posuere.
 *  Nullam luctus nisi ac lorem molestie, id sodales nisi tincidunt. Donec sit amet mi imperdiet
 *  mi ultricies ultrices. Curabitur ipsum dolor, faucibus non neque ut, eleifend lobortis lorem. 
 * </p>
 * 
 * $('#a-paragraph').ellipsizer(); // The paragraph's text will be truncated to 3 lines.
 * 
 * Additionally, Ellipsizer will by default set the height of the element to the maximum height for the specified number of lines.
 * If you want to keep the height automatic, add the css class "ellipsizer-fluid" to the element.
 * 
 */
(function($){
    /**
     * Creates an element that will be used to test the max height against.
     * 
     * @param {*} lineHeight The css property for line-height (in any units)
     * @param {number} numberOfLines
     */
    function createTestElement(lineHeight, numberOfLines) {
        var testElement = $('<div>')
            .css({
                display: 'block',
                position: 'absolute',
                opacity: 0,
                top: '-1000px',
                right: '1000px',
                padding: 0,
                height: lineHeight,
                overflow: 'hidden'
            });
    
        $('body').prepend(testElement);
        testElement.css({height: testElement.outerHeight() * numberOfLines});

        return testElement;
    }

    /**
     * The Ellipsizer jQuery extension.
     * 
     * @param {number|null} numberOfLinesArg
     */
    $.fn.ellipsizer = function(numberOfLinesArg = null) {
        this.each(function() {
            var $this = $(this);

            var numberOfLines = numberOfLinesArg;

            if(typeof(numberOfLines) != 'number') {
                numberOfLines = $this.data('ellipsizer-lines');
                if(typeof(numberOfLines) != 'number') { numberOfLines = 1; }
            }

            var $containingElement = $this;
            var $childElements = $this.find('p, span');
            if($childElements.length > 0) {
                $containingElement = $($childElements[0]);
            }

            var originalText = $this.data('original-text');
            if(!originalText) { originalText = $containingElement.text(); }
            $this.data('original-text', originalText);

            var originalOpacity = $this.css('opacity');
            var originalLineHeight = $containingElement.css('line-height');

            var testElement = createTestElement(originalLineHeight, numberOfLines);
    
            $this.css({
                overflow: 'hidden',
                height: 'auto',
                opacity: 0
            });
    
            var wordsArr = originalText.split(' ');
            if(wordsArr.length <= 0) { return; }
    
            var textArr = [];
            for(i = 0; i < wordsArr.length; i++) {
                textArr.push(wordsArr[i]);
                $this.html(textArr.join(' ') + '&hellip;');
                
                if($this.outerHeight() > testElement.outerHeight()) {
                    textArr.splice(i, 1);
                    break;
                }
            }

            var text = textArr.join(' ');
            if(textArr.length < wordsArr.length) {
                $this.attr('title', originalText);
                text = text + '&hellip;';
            } else {
                $this.attr('title', '');
            }

            $containingElement.html(text);
            if($containingElement != $this) {
                $this.html($containingElement);
            }

            var height = $this.hasClass('ellipsizer-fluid') ? 'auto' : testElement.outerHeight()
    
            $this.css({
                opacity: originalOpacity,
                height: height
            });

            testElement.remove();
    
        });
    }
})(jQuery);